import { Component } from '@angular/core';

@Component({
  selector: 'app-cards7-examples-43',
  templateUrl: './cards7-examples-43.component.html'
})
export class Cards7Examples43Component {}
